import cnhMM from "./i18n-data/cnh-mm.json";
import deDE from "./i18n-data/de-de.json";
import enGB from "./i18n-data/en-gb.json";
import enUS from "./i18n-data/en-us.json";
import esEC from "./i18n-data/es-ec.json";
import esPR from "./i18n-data/es-pr.json";
import esUS from "./i18n-data/es-us.json";
import frCA from "./i18n-data/fr-ca.json";
import frFR from "./i18n-data/fr-fr.json";
import frUS from "./i18n-data/fr-us.json";
import htUS from "./i18n-data/ht-us.json";
import idID from "./i18n-data/id-id.json";
import itIT from "./i18n-data/it-it.json";
import jaJP from "./i18n-data/ja-jp.json";
import koKR from "./i18n-data/ko-kr.json";
import myMM from "./i18n-data/my-mm.json";
import nlNL from "./i18n-data/nl-nl.json";
import noNO from "./i18n-data/no-no.json";
import ptBR from "./i18n-data/pt-br.json";
import ptPT from "./i18n-data/pt-pt.json";
import ruRU from "./i18n-data/ru-ru.json";
import svSE from "./i18n-data/sv-se.json";
import thTH from "./i18n-data/th-th.json";
import viVN from "./i18n-data/vi-vn.json";
import zhCN from "./i18n-data/zh-cn.json";
import zhHant from "./i18n-data/zh-hant.json";

export default {
  "cnh-mm": {data: cnhMM, name: "Hakha Chin"},
  "de-de": {data: deDE, name: "German"},
  "en-gb": {data: enGB, name: "English (GB)"},
  "en-us": {data: enUS, name: "English (US)"},
  "es-ec": {data: esEC, name: "Spanish (Ecuador)"},
  "es-pr": {data: esPR, name: "Spanish (Puerto Rico)"},
  "es-us": {data: esUS, name: "Spanish"},
  "fr-ca": {data: frCA, name: "French (Canadian)"},
  "fr-fr": {data: frFR, name: "French (France)"},
  "fr-us": {data: frUS, name: "French"},
  "ht-us": {data: htUS, name: "Creole"},
  "id-id": {data: idID, name: "Indonesian"},
  "it-it": {data: itIT, name: "Italian"},
  "ja-jp": {data: jaJP, name: "Japanese"},
  "ko-kr": {data: koKR, name: "Korean"},
  "my-mm": {data: myMM, name: "Burmese (Myanmar [Burma])"},
  "nl-nl": {data: nlNL, name: "Dutch"},
  "no-no": {data: noNO, name: "Norwegian"},
  "pt-br": {data: ptBR, name: "Portuguese (Brazil)"},
  "pt-pt": {data: ptPT, name: "Portuguese"},
  "ru-ru": {data: ruRU, name: "Russian"},
  "sv-se": {data: svSE, name: "Swedish"},
  "th-th": {data: thTH, name: "Thai"},
  "vi-vn": {data: viVN, name: "Vietnamese"},
  "zh-cn": {data: zhCN, name: "Chinese (Simplified)"},
  "zh-hant": {data: zhHant, name: "Chinese (Traditional)"}
};
